module.exports = __webpack_public_path__ + "img/simbolos_violeta.d7420064.jpeg";